import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  tryToGetOrganizationInvites,
  tryToGetOrganizationInvitesLog
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Retract an invite from an organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestRetractOrganizationInvite = packet => {
  return {
    type: 'REQUEST_RETRACT_ORGANIZATION_INVITE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveRetractOrganizationInviteSuccess = data => ({
  type: 'RECEIVE_RETRACT_ORGANIZATION_INVITE_SUCCESS',
  data
})

export const receiveRetractOrganizationInviteFail = data => ({
  type: 'RECEIVE_RETRACT_ORGANIZATION_INVITE_FAIL',
  data
})

export const tryToRetractOrganizationInvite = packet => (dispatch, getState) => {

  dispatch(requestRetractOrganizationInvite(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/organizations/invites/' + packet.id, {
      method: 'delete',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveRetractOrganizationInviteSuccess(json));
      dispatch(tryToGetOrganizationInvites({id: packet.id}));
      dispatch(tryToGetOrganizationInvitesLog({id: packet.id}));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveRetractOrganizationInviteFail({errors:e, lastSubmit: packet}));
    })
}
